"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.igMMessages = exports.igGMessages = exports.IgM = exports.IgG = void 0;
const schema_1 = require("../../../../schema");
var IgG;
(function (IgG) {
    IgG["POSITIVE"] = "POSITIVE";
    IgG["NEGATIVE"] = "NEGATIVE";
})(IgG || (exports.IgG = IgG = {}));
var IgM;
(function (IgM) {
    IgM["POSITIVE"] = "POSITIVE";
    IgM["NEGATIVE"] = "NEGATIVE";
})(IgM || (exports.IgM = IgM = {}));
exports.igGMessages = {
    [IgG.POSITIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.toxoplasma.igG.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [IgG.NEGATIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.toxoplasma.igG.NEGATIVE",
        defaultMessage: "Negatív"
    }
};
exports.igMMessages = {
    [IgM.POSITIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.toxoplasma.igM.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [IgM.NEGATIVE]: {
        id: "ktx.basicRegistrationData.viralSerology.toxoplasma.igM.NEGATIVE",
        defaultMessage: "Negatív"
    }
};
const igG = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(IgG.POSITIVE),
    schema_1.Schema.singleChoiceItem(IgG.NEGATIVE)
]);
const igM = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(IgM.POSITIVE),
    schema_1.Schema.singleChoiceItem(IgM.NEGATIVE)
]).optional();
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ igG, igM })
    .interpretation({ vocab: "ktx", code: "microbiological_toxoplasma" })
    .tag({ vocab: "snomed", code: "104305007", source: "synonym" })
    .tag({ vocab: "ktx", code: "microbiological_procedure" })
    .tag({ vocab: "loinc", code: "20464-4" })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "165994006" })
    .tag({ vocab: "loinc", code: "22580-5" });
